import { Group, Progress, Text } from '@mantine/core';

export interface ConfidenceIndicatorProps {
  value?: number | null;
  /** When value is 0–1 fraction instead of 0–100 percent */
  fraction?: boolean;
}

export function ConfidenceIndicator({ value, fraction = false }: ConfidenceIndicatorProps) {
  if (value === null || value === undefined) {
    return <Text c="dimmed">—</Text>;
  }

  const percent = fraction ? Math.round(value * 100) : Math.round(value);
  const color = percent >= 90 ? 'green' : percent >= 70 ? 'yellow' : 'red';

  return (
    <Group gap="xs" wrap="nowrap">
      <Text size="sm" fw={700}>{percent}%</Text>
      <Progress value={percent} color={color} w={72} size="xs" radius="xl" />
    </Group>
  );
}
